export default {
  methods: {
    returnUTCTime() {
      const d = new Date();
      const timeMilSec = d.getTime();
      const timeZone = d.getTimezoneOffset();
      const timeUTC = timeMilSec + timeZone * 60 * 1000;
      return timeUTC;
    },
  },
};
